import React from "react";
import { Helmet } from "react-helmet";
import tags from "../assets/metadata.json";
import image from "../assets/images/seoImage.webp";

const { title, description } = tags;

function Seo() {
  const url = typeof window !== "undefined" ? window.location.href : "/";
  const meta = ["og", "twitter"]
    .map((el) => {
      return [
        {
          property: `${el}:title`,
          content: title,
        },
        { property: `${el}:description`, content: description },
        {
          property: `${el}:url`,
          content: url,
        },
        {
          property: `${el}:image`,
          content: `${url.slice(0, -1)}${image}`,
        },
      ]
        .concat(el === "og" && [{ property: `${el}:type`, content: "website" }])
        .concat(
          el === "twitter" && {
            name: `${el}:card`,
            content: "summary_large_image",
          }
        )
        .concat({ name: "description", content: description });
    })
    .flat();

  return <Helmet title={title} meta={meta} />;
}

export default Seo;
